import React from "react";
import Icon from "components/AppIcon";

const stats = [
  { label: "Total Actualizaciones", value: "12", icon: "Package", color: "var(--color-primary)" },
  { label: "Asignaciones Activas", value: "47", icon: "Send", color: "var(--color-success)" },
  { label: "URLs por Vencer", value: "5", icon: "Clock", color: "var(--color-warning)" },
  { label: "Descargas Hoy", value: "23", icon: "Download", color: "var(--color-secondary)" },
];

const StatsBar = () => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
    {stats?.map((s) => (
      <div key={s?.label} className="flex items-center gap-3 p-3 md:p-4 rounded-xl" style={{ background: "var(--color-card)", boxShadow: "var(--shadow-sm)" }}>
        <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${s?.color}18` }}>
          <Icon name={s?.icon} size={20} color={s?.color} />
        </div>
        <div className="min-w-0">
          <p className="font-data font-bold text-lg leading-tight" style={{ color: "var(--color-foreground)" }}>{s?.value}</p>
          <p className="font-caption text-xs leading-tight" style={{ color: "var(--color-muted-foreground)" }}>{s?.label}</p>
        </div>
      </div>
    ))}
  </div>
);

export default StatsBar;